import { gql } from '@apollo/client'
/** AI大赛列表 */
export const GET_COMPETITION_LIST = gql`
  query getCompetitionList(
    $first: Int
    $offset: Int
    $param: CompetitionQueryInput
  ) {
    marketingModule {
      competitionPage(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            id
            name
            content
            status
            startStatus
            startDateTime
            endDateTime
            exquisitePainting
            artworkNum
            model
            modelTheme
            modelCode
            experimentAbility
            advancedSetting
            videoTime
            needLinkUrl
            needLinkAiCollection
            maxApplyNum
            minImage
            statistics {
              viewCount
            }
            type
            participate
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 单个大赛：后台配置的详情 */
export const GET_COMPETITION_DETAIL = gql`
  query getCompetitionDetail($id: Long) {
    marketingModule {
      competition(id: $id) {
        id
        name
        content
        startDateTime
        endDateTime
        status
        startStatus
        type
        needLinkAiCollection
        contributeTime
        contributeEndTime
      }
    }
  }
`

/**  单个大赛：数据统计 */
export const GET_COMPETITION_DATA_STATS = gql`
  query getCompetitionDataStats($param: ContestQueryInput!) {
    marketingModule {
      contestStatistics(param: $param) {
        # 浏览量
        viewCount
        # 参数用户
        count
        # 投稿数
        artworkCount
        voteStatistics {
          # 总投票数
          votesCount
        }
      }
    }
  }
`

/**  单个大赛：报导列表 */
export const GET_COMPETITION_NEWS = gql`
  query getCompetitionNews($id: Long) {
    marketingModule {
      competitionNewsPo(competitionId: $id) {
        id
        title
        link: content
        createTime: cTime
        coverImage
        newsTime
        newOriginal
      }
    }
  }
`

/** ai大赛获奖结果作品列表 */
export const GET_AI_COMPETITION_RESULT_LIST = gql`
  query getAiCompetitionResultList($id: Long) {
    marketingModule {
      competitionResult(id: $id) {
        artwork {
          id
          name
          artworkUrl
          type
          description
          gridImages
          creator: nArtist {
            uid
            avatarUrl
            nickname
            userRoleInfo {
              artist
              aiArtist
            }
            memberDetail {
              hold
            }
          }
          contestInfoExtra {
            expertComments
          }
          artworkSocialInfo {
            voteCount
          }
        }
        rank
        showTitle
        # 奖项名称
        leveL
        # 奖项名称key
        leveLValue
        # 综合评分
        score
      }
    }
  }
`

/** 单个大赛：投稿作品列表 */
export const GET_COMPETITION_PRODUCT_LIST = gql`
  query getCompetitionProductList(
    $first: Int
    $offset: Int
    $param: ArtworkQueryInput
  ) {
    itemModule {
      productList: artworkPage(
        page: { first: $first, offset: $offset }
        params: $param
      ) {
        edges {
          node {
            id
            name
            artworkUrl
            type
            gridImages
            creator: nArtist {
              uid
              avatarUrl
              userRoleInfo {
                artist
                aiArtist
              }
              memberDetail {
                hold
              }
            }
            imageBaseInfo {
              width
              height
            }
            artworkSocialInfo {
              voted
              voteCount
            }
            contestInfoExtra {
              rankFloating
              rank
              voter {
                uid
                avatarUrl
              }
            }
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 投稿设计大赛 */
export const APPLY_DRAFT_COMPETITION = gql`
  mutation applyDraftCompetition($param: DraftCompetitionArtworkInput) {
    itemModule {
      status: applyDraftCompetition(param: $param)
    }
  }
`

export const VOTE_COMPETITION = gql`
  mutation voteCompetition(
    $param: SocialActionInput!
    $checkParam: BehaviorCheckParam
  ) {
    status: itemModule {
      voteAction(param: $param, checkParam: $checkParam)
    }
  }
`

/** 投稿大赛 */
export const APPLY_COMPETITION = gql`
  mutation applyCompetition($param: AiCompetitionArtworkInput) {
    status: itemModule {
      applyAiCompetition(param: $param)
    }
  }
`

/** 投稿视频大赛 */
export const APPLY_VIDEO_COMPETITION = gql`
  mutation applyVideoCompetition($param: VideoCompetitionArtworkInput) {
    status: itemModule {
      applyVideoCompetition(param: $param)
    }
  }
`
/** 单个投稿作品详情 */
export const GET_COMPETITION_PRODUCT_DETAIL = gql`
  query getCompetitionProductDetail($id: Long!) {
    itemModule {
      artwork(id: $id) {
        creator: nArtist {
          nickname
          avatarUrl
          uid
          social {
            followStatus
          }
          userRoleInfo {
            artist
            aiArtist
          }
          memberDetail {
            hold
          }
        }
        id
        gridImages
        name
        artworkUrl
        artworkSourceUrl
        videoBaseInfo {
          width
          height
        }
        draftArtwork {
          imageUrl
          selfIntroduction
        }
        type
        description
        status
        artworkSocialInfo {
          voted
          voteCount
        }
        contestInfoExtra {
          competitionId
          prev: last
          next
          visibleType
          collectionPost {
            id
            title
            aiCollection {
              id
              visible
              aiArtworks(
                page: { offset: 0, first: 96 }
                param: { serviceStatuses: [CLEANED, GENERAL] }
              ) {
                edges {
                  cursor
                  node {
                    miniArtWorkUrl
                    id
                    width: length
                    height: width
                    serviceStatus
                  }
                }
                pageInfo {
                  hasNextPage
                  totalCount
                }
              }
            }
          }
        }
        chain {
          hash
          certificateNo
        }
        aiArtwork {
          pattern
          maskImageUrl
          modelTheme
          model
          prompt
          size
          specificSize
          initImageUrl
          multiReferenceImageUrlList
          generateTime
          styleDecorationOptions {
            key
            name
          }
          styleModelOption {
            key
            name
          }
          characterOptions {
            key
            name
          }
          modelFusionOptions: modelFusion {
            key
            name
            weight
          }
          hiddenBaseInfo
          technologyInfo {
            electricity
            gpuType
            serverId
          }
        }
      }
    }
  }
`
/** 大赛选择作品 */
export const GET_COMPETITION_ARTWORK_PAGE = gql`
  query getCompetitionArtWorkPage(
    $first: Int
    $offset: Int
    $param: CompetitionAiArtworkPageInput
  ) {
    pictureGraph {
      competitionAiArtworkPage(
        page: { first: $first, offset: $offset }
        input: $param
      ) {
        edges {
          node {
            keyOfInitParam
            artWorkUrl
            miniArtWorkUrl
            id
            status
            serviceType
            riskControl {
              status
              reason
            }
            maskImageUrl
            model
            size
            # 模式
            pattern
            # 同人角色
            character
            # 模型主题
            modelTheme
            # 模型代号
            modelCode
            # 模型融合
            modelFusion {
              key
            }
            # 精修信息
            prefineInfo {
              strength
            }
            extend {
              copyrightArtwork {
                id
                type
                status
              }
            }
            anyTextMode
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`
export const GET_COMPETITION_ARTWORK = gql`
  query getCompetitionArtWork($id: Long!, $collectionId: Long) {
    pictureGraph {
      aiArtwork(id: $id, aiCollectionId: $collectionId) {
        id
        keyOfInitParam
        artWorkUrl
        miniArtWorkUrl
        status
        initImageUrl
        multiReferenceImageUrlList
        size
        userName
        model
        specificSize
        width
        length
        involveYellow
        anyTextMode
        extend {
          copyrightArtwork {
            type
            status
          }
        }
        superSizePicInfo {
          artWorkUrl
          integral
          length
          multiple: multipleNew
          status
          width
        }
        riskControl {
          status
          reason
        }
        maskImageUrl
        # 模式
        pattern
        # 同人角色
        character
        # 模型主题
        modelTheme
        # 模型代号
        modelCode
        # 模型融合
        modelFusion {
          key
        }
        # 精修信息
        prefineInfo {
          strength
        }
        # 专业版 or 普通版
        serviceType
      }
    }
  }
`
// 专家评论列表
export const GET_EXPERT_COMMENT_LIST = gql`
  query getExpertCommentList($id: Long!) {
    copyrightItemModule {
      artwork(id: $id) {
        contestInfoExtra {
          expertComments
        }
      }
    }
  }
`
/** 获取大赛合集详情 */
export const GET_POST_COLLECTION_FOR_COMPETITION = gql`
  query getPostCollectionForCompetition($id: Long!, $offset: Int, $first: Int) {
    squareModule {
      squarePost(id: $id) {
        id
        title
        aiCollection {
          aiArtworks(page: { offset: $offset, first: $first }) {
            edges {
              cursor
              node {
                miniArtWorkUrl
                id
                width: length
                height: width
                serviceStatus
              }
            }
            pageInfo {
              hasNextPage
              totalCount
            }
          }
        }
      }
    }
  }
`

/** 首页大赛banner */
export const GET_COMPETITION_BANNER = gql`
  query getCompetitionBanner($size: Int!) {
    marketingModule {
      competitionBannerList(size: $size) {
        id
        name
        content
        status
        startStatus
        startDateTime
        endDateTime
      }
    }
  }
`
